import { CreditCard } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconCreditCard12Line = createIcon(CreditCard, 12, "Line");
export const IconCreditCard16Line = createIcon(CreditCard, 16, "Line");
export const IconCreditCard20Line = createIcon(CreditCard, 20, "Line");
export const IconCreditCard24Line = createIcon(CreditCard, 24, "Line");
export const IconCreditCard32Line = createIcon(CreditCard, 32, "Line");
export const IconCreditCard48Line = createIcon(CreditCard, 48, "Line");
export const IconCreditCard64Line = createIcon(CreditCard, 64, "Line");
